"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countTokens = void 0;
exports.countTokens = {
    allTokenHandler: global => {
        ++global._count;
    }
};
